import { render, staticRenderFns } from "./ContainersTabla.vue?vue&type=template&id=bf366244"
import script from "./ContainersTabla.vue?vue&type=script&lang=js"
export * from "./ContainersTabla.vue?vue&type=script&lang=js"
import style0 from "./ContainersTabla.vue?vue&type=style&index=0&id=bf366244&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports